import http from '../http'
import url from './index-url'
const { post } = http

export default {
  courseWareUnlock(data) {
    return post(url.courseWareUnlock, data)
  },
  courseWareInfo(data) {
    return post(url.courseWareInfo, data)
  },
  courseWareStartEnd({ id, status }) {
    return post(url.courseWareStartEnd(id, status))
  },
  courseWarePlayPause({ id, status }) {
    return post(url.courseWarePlayPause(id, status))
  },
  lessonPush(data) {
    return post(url.lessonPush, data)
  },
  lessonPushNumber(data) {
    return post(url.lessonPushNumber, data)
  }
}